import styled from "styled-components";

interface MainChartStyleProps {
  $prev?: boolean;
}

export const MainChartContents = styled.div`
  display: flex;
  padding: 20px;
  background: ${(props) => props.theme.colors.white};
  border-radius: 10px;
  box-shadow: ${(props) => props.theme.shadow.box};
  flex-direction: column;
  gap: 18px;
`;

export const ChartTit = styled.div`
  display: flex;
  padding-left: 4px;
  font-size: 1.6rem;
  align-items: center;
`;

export const ChartContent = styled.div`
  display: flex;
  width: 100%;
  gap: 40px;

  & > div + div {
    position: relative;

    &::before {
      position: absolute;
      content: "";
      display: block;
      height: 80%;
      top: 10%;
      left: -20px;
      border-left: 1px solid ${(props) => props.theme.colors.handleBg};
    }
  }
`;

export const Chart = styled.div`
  display: flex;
  width: 100%;
  // padding: 20px 0;
  // background: ${(props) => props.theme.colors.white};
  border-radius: 10px;
  // box-shadow: ${(props) => props.theme.shadow.box};
  align-items: center;
  flex-direction: column;
  gap: 16px;
`;

export const ChartText = styled.div<MainChartStyleProps>`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 2px;
`;

export const TextTit = styled.span<MainChartStyleProps>`
  font-size: 1.3rem;
  font-weight: 400;
  white-space: nowrap;
`;

export const TextValue = styled.span<MainChartStyleProps>`
  color: ${(props) => props.theme.colors.primary};
  font-size: 1.8rem;
  font-weight: 600;
  white-space: nowrap;
`;
